import IQuestionsDataStore from '../IQuestionsDataStore'
import { API } from 'aws-amplify'

class AWSQuestionsDataStore extends IQuestionsDataStore {

  post = (questions) => {
    return new Promise(function (resolve, reject) {
      try {
        API.post('questions', '/questions', {
            body: questions,
            response: true,
            headers: {
              Accept: 'application/json',
          }
        })
        .then( (response) => {
          resolve({'status': response.status,'statusText': response.data})
        })
        .catch( (err) => {
          let res = {}
          if (err.response === undefined) {
            res = {status: '499', statusText: 'POST Internal Error', error: err}
            console.error('Error internal POST questions: ', JSON.stringify(err))
          } else {
            res = {
              status: err.response.status,
              statusText: err.response.data
            }
            console.error('Error reponse POST questions: ', JSON.stringify(res))
          }
          reject( res )
        })
      } catch(e) {
        console.error('Error internal POST Exception: ', JSON.stringify(e))
        reject({status: '499', statusText: 'Internal POST Exception', exception: e})
      }
    })
  }

  get = (product='IntroLine', version='current') => {
    return new Promise(function (resolve, reject) {
      try {
        API.get('questions', `/questions/object/${product}/${version}`, {
            response: true,
            headers: {
              Accept: 'application/json',
            }
        })
        .then((res) => {
          // console.log('Questions GET response: ', JSON.stringify(res.data))
          if (res && res.data && res.data.questions) {
            resolve(res.data.questions)
          } else {
            console.error('Questions GET questions data missing: ',
                JSON.stringify(res, null, 2))
            throw new {response:
              { status: '500',
                statusText: 'Questions GET response missing "data" attribute'
              }
            }()
          }
        })
        .catch ((err) => {
          let res = {}
          if (err.response === undefined) {
            res = {status: '499', statusText: 'POST Internal Error', error: err}
          } else {
            res = {
              status: err.response.status,
              statusText: err.response.data
            }
          }
          console.error('Error POST questions: ', JSON.stringify(res))
          reject( res )
        })
      } catch (e) {
        console.error('Error internal POST Exception: ', JSON.stringify(e))
        reject({status: '499', statusText: 'Internal POST Exception', exception: e})
      }
    })
  }
  
  getList = (version) => {
    return new Promise(function (resolve, reject) {
      try {
        API.get('questions', '/questions', {
            response: true,
            headers: {
              Accept: 'application/json',
            }
        })
        .then((res) => {
          console.log('Questions LIST response: ', JSON.stringify(res.data))
          if (res && res.data && res.data) {
            resolve(res.data)
          } else {
            console.error('Questions LIST questions data missing: ',
                JSON.stringify(res, null, 2))
            throw new {response:
              { status: '500',
                statusText: 'Questions LIST response missing "data" attribute'
              }
            }()
          }
        })
        .catch ((err) => {
          let res = {}
          if (err.response === undefined) {
            res = {status: '499', statusText: 'LIST Internal Error', error: err}
          } else {
            res = {
              status: err.response.status,
              statusText: err.response.data
            }
          }
          console.error('Error LIST questions: ', JSON.stringify(res))
          reject( res )
        })
      } catch (e) {
        console.error('Error internal LIST Exception: ', JSON.stringify(e))
        reject({status: '499', statusText: 'Internal LIST Exception', exception: e})
      }
    })
  }

  delete = (version) => {
    return new Promise(function (resolve, reject) {
      try {
        API.del('questions', '/questions/object/' + version, {
            response: true,
            headers: {
              Accept: 'application/json',
            }
        })
        .then((res) => {
          console.log('Questions DELETE response: ', JSON.stringify(res.data))
          if (res && res.data && res.data) {
            resolve(res.data)
          } else {
            console.error('Questions DELETE questions data missing: ',
                JSON.stringify(res, null, 2))
            throw new {response:
              { status: '500',
                statusText: 'Questions DELETE response missing "data" attribute'
              }
            }()
          }
        })
        .catch ((err) => {
          let res = {}
          if (err.response === undefined) {
            res = {status: '499', statusText: 'DELETE Internal Error', error: err}
          } else {
            res = {
              status: err.response.status,
              statusText: err.response.data
            }
          }
          console.error('Error DELETE questions: ', JSON.stringify(res))
          reject( res )
        })
      } catch (e) {
        console.error('Error internal DELETE Exception: ', JSON.stringify(e))
        reject({status: '499', statusText: 'Internal DELETE Exception', exception: e})
      }
    })
  }

  create(questions) {
    return this.post(questions)
  }

  retrieve(product, version) {
    return this.get(product, version)
  }

  store(questions) {
    return this.post(questions)
  }

  list() {
    return this.getList()
  }

  remove(version) {
    return this.delete(version)
  }

}

export default AWSQuestionsDataStore